import React from 'react'
import { useRadioGroup } from '@mui/material'
import styled, { useTheme } from 'styled-components'
import { buttonStyles, ButtonContent, ButtonStyleProps } from './Button'

interface SelectButtonProps {
  value: string
  label: string
}

export const RadioSelectButton: React.FC<SelectButtonProps> = ({ label, value }) => {
  const radioGroup = useRadioGroup()
  const { colors } = useTheme()

  if (!radioGroup) {
    return null
  }
  const checked = radioGroup.value === value
  const id = (radioGroup.name ?? '').concat(value).trim()

  const [backgroundColor, fontColor] = checked
    ? [colors.secondary.medium, colors.white]
    : [colors.white, colors.secondary.medium]

  return (
    <>
      <StyledInput
        id={id}
        name={radioGroup.name}
        value={value}
        checked={checked}
        onChange={(e) => radioGroup.onChange(e, e.target.value)}
      />
      <StyledLabel
        size="large"
        backgroundColor={backgroundColor}
        disabled={false}
        inverse={false}
        fullWidth={false}
        iconAligned="left"
        htmlFor={id}
      >
        <ButtonContent iconAligned="left" fontColor={fontColor}>
          {label}
        </ButtonContent>
      </StyledLabel>
    </>
  )
}

const StyledInput = styled.input.attrs({ type: 'radio' })`
  opacity: 0;
  position: fixed;
  width: 0;
  &:focus + label {
    box-shadow: 0 0 0 0.2rem ${({ theme }) => theme.colors.success.dark};
  }
`

const StyledLabel = styled.label<ButtonStyleProps>`
  line-height: 0;
  ${buttonStyles}
`
